import { render } from "./EditNote.vue?vue&type=template&id=0b16af4a"
import script from "./EditNote.vue?vue&type=script&lang=js"
export * from "./EditNote.vue?vue&type=script&lang=js"

import exportComponent from "/home/crm/ganarcrm_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__